import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = {
  class: "modal-content",
  style: {"height":"calc(100vh - 50px)"}
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "table table-hover" }
const _hoisted_9 = { style: {"width":"20%"} }
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_12 = {
  class: "dropdown-menu",
  role: "menu"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { style: {"width":"20%"} }
const _hoisted_16 = {
  key: 0,
  class: "progress",
  style: {"margin":"0"}
}
const _hoisted_17 = ["title"]

import { computed } from 'vue'

    import { SubSurveysManagerDialogViewModel } from '@Evaluation/AlternativesSurveys/Components/SubSurveysManagerDialog'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SubSurveysManagerDialog',
  props: {
    viewModel: {}
  },
  emits: ["include-sub-survey", "change-vote-strength", "exclude-sub-survey"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const vm = computed(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    /* ---------------- derived ---------------- */

    const initialized = computed(() => vm.value.rm != null)
    const masterSurveyId = computed(() => vm.value.masterSurveyId)
    const masterSurveyName = computed(() => vm.value.masterSurveyName)
    const entries = computed(() => vm.value.rm?.Entries ?? [])

    /* ---------------- actions ---------------- */

    function emitIncludeSubSurvey(surveyId: number, voteStrength: number)
    {
        const s = entries.value.find(e => e.Id === surveyId)
        if (!s) return

        if (s.IsIncluded === false)
        {
            emit('include-sub-survey', masterSurveyId.value, surveyId, voteStrength)
        } else if (s.IsIncluded === true && s.VoteStrength !== voteStrength)
        {
            emit('change-vote-strength', masterSurveyId.value, surveyId, voteStrength)
        }
    }

    function emitExcludeSubSurvey(surveyId: number)
    {
        const s = entries.value.find(e => e.Id === surveyId)
        if (!s) return

        if (s.IsIncluded === true)
        {
            emit('exclude-sub-survey', masterSurveyId.value, surveyId)
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Combined panels", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (initialized.value === false)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", {
                        class: "alert alert-info",
                        role: "alert"
                      }, " You can include another panel as if it were a respondent. This lets you, for example, combine and compare votes from different groups of people. ", -1 /* CACHED */)),
                      _createElementVNode("div", null, [
                        _createElementVNode("table", _hoisted_8, [
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entries.value, (s) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: s.Id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(s.Name), 1 /* TEXT */),
                                _createElementVNode("td", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("a", _hoisted_11, _toDisplayString(s.IsIncluded ? `Vote strength ${s.VoteStrength}` : "Not included"), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (emitExcludeSubSurvey(s.Id))
                                      }, "Not included", 8 /* PROPS */, _hoisted_13),
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (num) => {
                                        return _createElementVNode("a", {
                                          key: num,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (emitIncludeSubSurvey(s.Id, num - 1))
                                        }, " Vote strength: " + _toDisplayString(num - 1), 9 /* TEXT, PROPS */, _hoisted_14)
                                      }), 64 /* STABLE_FRAGMENT */))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_15, [
                                  (s.IsIncluded)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("div", {
                                          style: _normalizeStyle({ width: s.Progress + '%' }),
                                          title: s.Progress,
                                          class: "progress-bar progress-bar-success progress-bar-striped",
                                          role: "progressbar"
                                        }, null, 12 /* STYLE, PROPS */, _hoisted_17)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})